import React from 'react';
import { BellIcon } from 'lucide-react';
export function NotificationBadge({
  count = 0,
  onClick
}) {
  return <button className="relative p-1 rounded-full hover:bg-gray-100" onClick={onClick} aria-label={count === 0 ? 'No notifications' : `${count} unread notifications`} data-id="element-325">
      <BellIcon className="w-6 h-6 text-gray-500" data-id="element-326" />
      {count > 0 && <span className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center" data-id="element-327">
          {count > 9 ? '9+' : count}
        </span>}
    </button>;
}